import { render } from "./NewNatureOfCargo.vue?vue&type=template&id=4c26b5bf"
import script from "./NewNatureOfCargo.vue?vue&type=script&lang=js"
export * from "./NewNatureOfCargo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\oaromasodun\\Desktop\\MarinePortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__